/* @flow */
import * as React from 'react';
import Row from 'components/Row';
import Text from 'components/Text';
import Button from 'components/Button';
import Confetti from 'components/Confetti';
import { withRouter } from 'app/context/Router';
import WizardHeader from 'components/WizardHeader';
import IntegrationWizardHeaderContent from 'admin/components/IntegrationWizardHeaderContent';

import './styles/ACISuccess.scss';

type Props = {
  name: string,
  router: any,
  iconURL: string,
};

class ACISuccess extends React.Component<Props, {}> {
  goBack = () => this.props.router.goBack();

  render() {
    return (
      <div className="ACISuccess">
        <Confetti />
        <WizardHeader>
          <IntegrationWizardHeaderContent title={this.props.name} iconURL={this.props.iconURL} />
        </WizardHeader>
        <div className="ACISuccess-content">
          <div>
            <Row>
              <Text className="ACISuccess-content-title" size="xxlarge" element="div">
                All set! {this.props.name} is now set up.
              </Text>
            </Row>
            <Button onClick={this.goBack}>Go to Integrated apps</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ACISuccess);
